import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Col, Row } from 'react-bootstrap';
import NotificationsSelectorComponent from './NotificationsSelectorComponent';

/* eslint no-unused-vars: */
const NotificationsComponent = ({
  notificationRequestsByRuleId,
  notificationRules,
  showFavoritesOnly,
  subscribe,
  toggleFavoritesOnly,
  unsubscribe
}) => (
  <div>
    <Row>
      <Col mdOffset={10}>
        <Checkbox
          style={{ marginLeft: '10px' }}
          checked={showFavoritesOnly}
          onChange={toggleFavoritesOnly}
        >
          Show Favorites Only
        </Checkbox>
      </Col>
    </Row>
    <Row>
      {notificationRules.filter(rule => {
        if (!showFavoritesOnly) {
          return true;
        }
        const request = notificationRequestsByRuleId[rule.id];
        return request && request.config.is_favorite;
      }).map((rule, index) =>
      {
        const subscribed = notificationRequestsByRuleId[rule.id];
        const favorited = subscribed && subscribed.config.is_favorite;
        return (
          <NotificationsSelectorComponent
            key={index}
            isSubscribed={!!subscribed}
            isFavorite={!!favorited}
            config={subscribed && subscribed.config}
            request={subscribed}
            rule={rule}
            onSubmit={subscribe}
            onUnsubscribe={unsubscribe}
          />
        );
      })}
    </Row>
  </div>
);

NotificationsComponent.propTypes = {
  notificationRequestsByRuleId: PropTypes.object.isRequired,
  notificationRules: PropTypes.array.isRequired,
  showFavoritesOnly: PropTypes.bool,
  subscribe: PropTypes.func.isRequired,
  toggleFavoritesOnly: PropTypes.func.isRequired,
  unsubscribe: PropTypes.func.isRequired,
};

export default NotificationsComponent;


// WEBPACK FOOTER //
// src/Components/NotificationsComponent.js